export const APP_CONTAINER_ID = "app-container";
export const PLAYBACK_WARMUP_MS = 300;
export const PLAYBACK_SEQUENCE_GAP_MS = 200;
export const RECORDING_START_MS = 500;
export const RECORDING_ORANGE_START_RATIO = 0.8;
